import { useState, useEffect } from "react";
import { AxiosResponse } from "axios";
import BatchesDataTable from "features/payslips/BatchesDataTable";
import Backdrop from "components/Backdrop";

import IconButton from "components/IconButton";
import { fetchAllBatchesWithSearchAPI, fetchBatchPageAPI } from "api/apiHelper";
import { BatchType, PaginatedResponse } from "types/payroll-types";
import { usePermissions } from "app/hooks";
import ErrorBox from "components/ErrorBox";

const PayslipBatches = () => {
  const [batches, setBatches] = useState<BatchType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [paginationData, setPaginationData] = useState<PaginatedResponse<BatchType> | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const permissions = usePermissions() || [];
  const [pageSize, setPageSize] = useState<number>(10);


  const getPayslipsBatches = async () => {
    setIsLoading(true);
    try {
      const response: AxiosResponse<PaginatedResponse<BatchType>> = 
        await fetchAllBatchesWithSearchAPI(pageSize, searchTerm);
      console.log("Batches : ", response.data);
      setPaginationData(response.data);
      setBatches(response.data.results);
      setCurrentPage(1);
      setIsLoading(false);
      setError("");
    } catch (error: any) {
      console.log(error);
      setError(error.message);
      setIsLoading(false);
    }
  };

  const getBatchesPage = async (pageUrl: string, action: string) => {
    setIsLoading(true);
    try {
      const response: AxiosResponse<PaginatedResponse<BatchType>> = 
        await fetchBatchPageAPI(pageUrl);
      setPaginationData(response.data);
      setBatches(response.data.results);
      setCurrentPage((prev) => (action === "next" ? prev + 1 : prev - 1));
      setIsLoading(false);
    } catch (error: any) {
      console.log(error);
      setError(error.message);
      setIsLoading(false);
    }
  };

  const handlePageSizeChange = (newSize: number) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };

  const handleSearch = async () => {
    getPayslipsBatches();
  };

  useEffect(() => {
    
    getPayslipsBatches();
  }, [pageSize]);

  return (
    <div className="container mt-5">
      {isLoading ? (
        <Backdrop show={isLoading} />
      ) : (
        <div>
          {error && <ErrorBox errorMessage={error} />}

          <div className="flex md:flex-row md:justify-between items-center mb-4">
            <div className="flex flex-wrap justify-start">
              {permissions && permissions.includes('payroll.view_payslip') &&
                <IconButton url="/payslip/" name="Payslips" icon="fas fa-tasks" extraStyles="mb-2 md:mb-0" />
              }
            </div>
            <div className="flex flex-wrap justify-end md:justify-end">
              {permissions && permissions.includes('payroll.add_payslipbatch') &&
                <IconButton url="/payslip/batch/create" name="Create Batch" icon="fas fa-plus" extraStyles="mb-2 md:mb-0" />
              }
            </div>
          </div>

          {/* Search Bar */}
          <div className="mb-4 flex gap-2">
            <input
              type="text"
              placeholder="Search by ID, month, or period..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={handleSearch}
              className="px-6 py-2 bg-brand-500 text-white font-bold rounded-lg hover:bg-brand-600 dark:bg-brand-400 dark:hover:bg-brand-500"
            >
              Search
            </button>
          </div>

          {batches && (
            <BatchesDataTable 
              tableData={batches}
              tableName="Batches"
              paginationData={paginationData}
              currentPage={currentPage}
              pageSize={pageSize}
              getBatchesPage={getBatchesPage}
              onPageSizeChange={handlePageSizeChange}

            />
          )}
        </div>
      )}
    </div>
  );
};

export default PayslipBatches;